module.exports = __webpack_public_path__ + "img/EYE-BG-OS.cf0aa320.svg";